module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPrivacyProgress || _vm.isAdmin) ? _c('profile-gallery', {
    attrs: {
      "images": _vm.images,
      "isOwner": _vm.isOwner
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyProgress && !_vm.isAdmin) ? _c('p', [_vm._v("User has chosen to keep their gallery private")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0c2217","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileGallery.vue
// module id = 3661
// module chunks = 1